import { render, staticRenderFns } from "./print-pdf.vue?vue&type=template&id=6b2459f2"
import script from "./print-pdf.vue?vue&type=script&lang=js"
export * from "./print-pdf.vue?vue&type=script&lang=js"
import style0 from "./print-pdf.vue?vue&type=style&index=0&id=6b2459f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports